exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dark {\n  color: black;\n}\n.p2 {\n  padding-left: 4px !important;\n  padding-right: 4px;\n}\n", ""]);

// exports
